import { useRef } from 'react';
import { toIntent } from '../../intent';
import { onRender } from '../intentTypes';
import { useIsomorphicLayoutEffect } from '../../util';
import { useCurrentTimeline } from '../../animate/timeline';
import { NodeAnimation } from '../../animate/animate';
export function normalizeKeyframe(keyframe) {
    const { delay, duration, easing, ...styles } = keyframe;
    return {
        styles: styles,
        options: {
            delay,
            duration,
            easing
        }
    };
}
function refAnimation(animationRef, styles, options) {
    return onRender(()=>{
        const ref = useRef(null);
        const timeline = useCurrentTimeline();
        useIsomorphicLayoutEffect(()=>{
            if (animationRef.current === null) {
                animationRef.current = new NodeAnimation(timeline, ref, styles, options);
            }
        }, [
            timeline
        ]);
        return [
            {
                ref
            }
        ];
    });
}
function conditionalAnimation(condition, styles, options) {
    return onRender(()=>{
        const ref = useRef(null);
        const pushedTask = useRef(null);
        const timeline = useCurrentTimeline();
        const animationRef = useRef(null);
        useIsomorphicLayoutEffect(()=>{
            if (animationRef.current === null) {
                animationRef.current = new NodeAnimation(timeline, ref, styles, options);
            }
            const animation = animationRef.current;
            if (condition) {
                if (pushedTask.current == null) {
                    pushedTask.current = animation.play({
                        push: true
                    });
                }
            } else if (ref.current && pushedTask.current != null) {
                pushedTask.current.removeAndPlay();
                pushedTask.current = null;
            }
        });
        return [
            {
                ref
            }
        ];
    });
}
function presenceAnimation(keyframe, type, reverse) {
    const { styles, options } = normalizeKeyframe(keyframe);
    if (reverse) {
        options.reverse = reverse;
    }
    return onRender(()=>{
        const ref = useRef(null);
        const timeline = useCurrentTimeline();
        useIsomorphicLayoutEffect(()=>{
            const animation = new NodeAnimation(timeline, ref, styles, options);
            return timeline.register(type, animation);
        }, [
            timeline
        ]);
        return [
            {
                ref
            }
        ];
    });
}
function isTestEnv() {
    if (process.env.NODE_ENV === 'test') {
        return true;
    }
    return false;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const noopIntent = onRender(()=>{});
export function transition(keyframe) {
    const { styles, options } = normalizeKeyframe(keyframe);
    return {
        when: (condition)=>{
            if (isTestEnv()) {
                return noopIntent;
            }
            return conditionalAnimation(condition, styles, options);
        },
        ref: (ref)=>{
            if (isTestEnv()) {
                return noopIntent;
            }
            return refAnimation(ref, styles, options);
        }
    };
}
export function transitionIn(keyframe) {
    if (isTestEnv()) {
        return noopIntent;
    }
    return presenceAnimation(keyframe, 'in', 'keyframes');
}
export function transitionOut(keyframe) {
    if (isTestEnv()) {
        return noopIntent;
    }
    return presenceAnimation(keyframe, 'out');
}
export function transitionInOut(keyframe) {
    if (isTestEnv()) {
        return noopIntent;
    }
    return toIntent([
        presenceAnimation(keyframe, 'in', 'keyframes'),
        presenceAnimation(keyframe, 'out', 'effects')
    ]);
}

//# sourceMappingURL=transitions.js.map